import React, { memo, useMemo  } from 'react';
import { FaSignOutAlt } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';
//import DynamicMenu from '../DynamicMenu';      // ✅ single import
import Index from '../DynamicMenu/index';
import './SideMenu.css';
import './Side.css';
//import { useAuth } from "../context/AuthContext"; // use this path as you requested

const SideMenu = ({ isOpen, darkMode = false }) => {
  const { authData, handleLogout } = useAuth();
  const hotelName = authData?.hotelName || "Hotel";

  const logoText = useMemo(() => {
    const first = (hotelName || "").trim().charAt(0).toUpperCase();
    return first || "H";
  }, [hotelName]);
  
  return (
    <div
      className={`side-menu ${isOpen ? 'open' : 'closed'} ${
        darkMode ? 'dark-mode' : ''
      }`}
    >
      {/* ─ App name header (no user profile) ───────────────────── */}
      {isOpen && (
        <div className="sidebar-brand">
          <div className="sidebar-logo-circle" title={hotelName}>
            {logoText}
          </div>

          <div className="sidebar-brand-text">
            <div className="sidebar-hotel-name">{hotelName}</div>
          </div>
        </div>
      )}

      {/* ─ menu items ──────────────────────────────────────────── */}
      <div className="menu-section">
        <Index showLabels={isOpen} />
      </div>

      {/* ─ logout footer (optional – keep if you want it) ──────── 
      {isOpen && (
        <div className="menu-footer">
          <button onClick={handleLogout} className="logout-button">
            <FaSignOutAlt className="icon" />
            Logout
          </button>
        </div>
      )}  */}
    </div>
  );
};

export default memo(SideMenu);
